import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamMarksAutomationLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ExamMarksAutomation' */ './ExamMarksAutomation'
		)
);

export default (store) => {
	return {
		path: 'exam-marks-automation/:campusId?',
		element: <AsyncLoading component={<ExamMarksAutomationLazy />} />,
		children: [],
	};
};
